/**
 * Owner: Haselton Baker Risk Group, LLC
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 4/5/17
 * Copyright All Rights Reserved
 */
// @flow
import * as React from 'react';
import ProtectedRoute from '../ProtectedRoute';

type Props = {
  component: React.ComponentType<any>,
  path: string,
  isAdmin: boolean,
  isAuthenticated: boolean,
};

const AdminRoute = ({
  component, isAdmin, isAuthenticated, path, ...rest
}: Props) => (
  <ProtectedRoute
    {...rest}
    component={component}
    isAuthorized={isAuthenticated && isAdmin}
    path={path}
    redirect="/inventory"
  />
);

export default AdminRoute;



// WEBPACK FOOTER //
// ./js/components/support/routing/AdminRoute/AdminRoute.jsx